import jsonExport from "jsonexport/dist";
import { downloadCSV } from "react-admin";
import { DataProvider, getListParamsFromHash } from "./helpers/exporterUtils";

const QUOTE_EXPORT_FIELDS = [
  // --- Business / user ---
  "business_name",
  "address",
  "user",
  "uid",

  // --- Quote identifiers ---
  "quote_id",
  "session",
  "product",
  "flow_type",
  "carrier",

  // --- Pricing ---
  "yearly_premium",
  "monthly_premium",
  "term",

  // --- Policy ---
  "policy_number",
  "policyNumber",
  "expires_on",

  // --- Status ---
  "completed",
  "completed_ts",
  "notify",

  // --- System / file ---
  "id",
  "timestamp",
  "metadata",
  "filetype",
  "filename",
  "orig_filename",
  "key",
];

const toCell = (v: any): any => {
  if (v === null || v === undefined) return "";
  if (typeof v === "object") return JSON.stringify(v);
  return v;
};

export const quotesExporter = async (
  _records: any[],
  _fetchRelatedRecords: any,
  dataProvider: DataProvider,
  resource: string
) => {
  const { sort, filter } = getListParamsFromHash({
    sortField: "ts",
    sortOrder: "DESC",
  });

  // Use getList so auth headers (baked into dataProvider via closure) are used automatically.
  // getList internally calls fetchAllQuotes with cursor pagination and caches the result.
  const response = await dataProvider.getList(resource, {
    pagination: { page: 1, perPage: 100000 },
    sort,
    filter,
  });

  const rows = response.data.map((quote: any) => {
    const normalised = { ...quote };

    // Normalise ts → timestamp (RFC 1123)
    if (normalised.ts) {
      const tsValue = Number(normalised.ts);
      const dateObj = tsValue > 1e12 ? new Date(tsValue) : new Date(tsValue * 1000);
      normalised.timestamp = dateObj.toUTCString();
      delete normalised.ts;
    }

    const row: any = {};
    QUOTE_EXPORT_FIELDS.forEach((key) => {
      row[key] = toCell(normalised[key]);
    });
    Object.keys(normalised).forEach((key) => {
      if (!(key in row)) row[key] = toCell(normalised[key]);
    });
    return row;
  });

  const dynamicHeaders = Array.from(
    new Set(rows.flatMap((r: any) => Object.keys(r).filter((k) => !QUOTE_EXPORT_FIELDS.includes(k))))
  );
  const columnHeaders = [...QUOTE_EXPORT_FIELDS, ...dynamicHeaders];

  const fileName = resource.trim().replace(/(\.csv)+$/i, "");
  jsonExport(rows, { headers: columnHeaders, rowDelimiter: "," }, (err: any, csv: string) => {
    if (err) console.error(err);
    else downloadCSV(csv, fileName);
  });
};